import React, { useState, useEffect } from 'react';
import { Card } from '../../ui/card';
import { EditAssessmentQuestions } from './EditAssessmentQuestions';
import { EditAssessmentTitle } from './EditAssessmentTitle';
import { EditAssessmentInstructions } from './EditAssessmentInstructions';
import { EditAssessmentTags } from './EditAssessmentTags';

interface EditAssessmentProps {
  assessmentId: string;
  selectedTab: 'title' | 'instructions' | 'questions' | 'tags';
}

const TABS = [
  { id: 'title' as const, label: 'Title/Description' },
  { id: 'instructions' as const, label: 'Instructions' },
  { id: 'questions' as const, label: 'Questions & Sections' },
  { id: 'tags' as const, label: 'Tags' }
];

export function EditAssessment({ assessmentId, selectedTab }: EditAssessmentProps) {
  const [localTab, setLocalTab] = useState<'title' | 'instructions' | 'questions' | 'tags'>(selectedTab);

  useEffect(() => {
    setLocalTab(selectedTab);
  }, [selectedTab]);

  return (
    <div className="space-y-4 max-w-6xl mx-auto p-6">
      <Card className="p-1">
        <div className="flex flex-col lg:flex-row gap-1">
          {TABS.map((tab) => {
            const isActive = localTab === tab.id;
            return (
              <button
                key={tab.id}
                onClick={() => setLocalTab(tab.id)}
                className={`
                  flex-1 px-4 py-2 text-sm font-medium rounded transition-colors
                  ${isActive
                    ? 'bg-action-blue text-white'
                    : 'text-gray-600 hover:bg-gray-100'
                  }
                `}
              >
                {tab.label}
              </button>
            );
          })}
        </div>
      </Card>

      <div className="mt-2">
        {localTab === 'title' && <EditAssessmentTitle assessmentId={assessmentId} />}
        {localTab === 'instructions' && <EditAssessmentInstructions assessmentId={assessmentId} />}
        {localTab === 'questions' && <EditAssessmentQuestions assessmentId={assessmentId} />}
        {localTab === 'tags' && <EditAssessmentTags assessmentId={assessmentId} />}
      </div>
    </div>
  );
}
